import React, {useContext, useState, useEffect} from "react";
import Button from '@material-ui/core/Button';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import {ProviderRequestsContext} from "../../context/ProviderRequestsContext";

const canAllowNext = (activeStep, selectedProviders, consentTerms) => {
    switch (activeStep) {
        case 0:
            return !!selectedProviders.length;
        case 1:
            return !!consentTerms;
        default:
            return true;
    }
}

export default function ActionsContainer(props) {
    const {activeStep, handlePrev, handleNext, handleSubmit, classes, consentTerms} = props;
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const [allowNext, setAllowNext] = useState(false);

    useEffect(() => {
        setAllowNext(canAllowNext(activeStep, providerRequestsContext.state.selectedProviders, consentTerms));
    }, [activeStep, providerRequestsContext.state.selectedProviders, consentTerms]);

    return (
        <div className={classes.actionsContainer}>
            {activeStep === 1 ?
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.fullWidthButton}
                    disabled={!allowNext}
                >
                    CONFIRM <ChevronRightIcon/>
                </Button> : ''
            }
            {activeStep > 0 ?
                <Button
                    fullWidth
                    variant="text"
                    onClick={handlePrev}
                    className={`${classes.prevButton}`}
                    color="secondary"
                >
                    <ChevronLeftIcon/>
                    ÎNAPOI
                </Button> : ''
            }
            {activeStep < 1 ?
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.fullWidthButton}
                    disabled={!allowNext}
                >
                    CONTINUĂ <ChevronRightIcon/>
                </Button> : ''
            }
        </div>
    )
}